import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../components/Header";
import CourseTable from "./components/CourseTable";
import Style from "./Main.module.scss";
import {
    allCourses,
    CourseItem,
    getCourseData,
    getCurrentDate,
    trimTitle
} from "service/service";
import useRequest from "../../../utils/useRequest";
import _ from "underscore";
import LoadingWrapper from "../../../components/LoadingWrapper";
import { Tabs } from "antd";
import { useSearchParam } from "react-use";
import { useHistory } from "react-router-dom";

export default function PageHomeworkMain() {
    const { TabPane } = Tabs;

    const [list, setList] = useState<CourseItem[]>([]);

    const [CourseData, { loading }] = useRequest(() => getCourseData({}));
    const [currentDate, { loading: loadingDate }] = useRequest(() =>
        getCurrentDate()
    );

    const courses = useMemo(() => allCourses(CourseData || []), [CourseData]);

    const onSelectChange = (key?: string) => {
        if (!CourseData || !courses) return;

        const courseUniqueId = courses[Number(key) || 0]?.courseUniqueId;

        const list = _.filter(CourseData, item => {
            return item.courseUniqueId == courseUniqueId;
        });

        setList(list);
    };
    const [activeKey, setActiveKey] = useState(useSearchParam("key") || "0");

    const history = useHistory();

    const onTabChange = (key: string) => {
        setActiveKey(key);
        history.replace(`?key=${key}`);
    };

    useEffect(() => {
        onSelectChange(activeKey);
    }, [activeKey, CourseData]);

    return (
        <div>
            <Header />
            <LoadingWrapper
                isEmpty={
                    !CourseData || !currentDate || CourseData!.length === 0
                }
                loading={loading || loadingDate}>
                {() => (
                    <div className={Style.root}>
                        <Tabs
                            type="card"
                            defaultActiveKey={activeKey}
                            onChange={onTabChange}>
                            {courses.map((course, index) => (
                                // @ts-ignore
                                <TabPane
                                    tab={`${trimTitle(course.courseName, 8)}-${
                                        course.courseSeq
                                    }`}
                                    key={index.toString()}>
                                    <div className={Style.table}>
                                        <CourseTable list={list} />
                                    </div>
                                </TabPane>
                            ))}
                        </Tabs>
                    </div>
                )}
            </LoadingWrapper>
        </div>
    );
}
